import { QueryClient } from '@tanstack/react-query'

// Shared singleton so non-React callers (e.g. the runtime-host `getEntities` bridge) can read through
// the same cache the React hooks populate, rather than firing parallel uncached requests.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
})

export default queryClient
